import * as React from 'react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import userManager from './userManager';
import { deleteBasicData } from 'DataBase/BasicDataDB';
import CacheNames from 'Application/Common/Constants/CacheNames';

const CantLogin = (): ReactElement => {
    const [t] = useTranslation()

    const deleteUserData = async () => {
        await deleteBasicData(CacheNames.UserAccessList)
        await deleteBasicData(CacheNames.UserProfile);
        await deleteBasicData(CacheNames.InsuranceExpertFieldsCurrentUser)
    }

    return (
        <div className="p-4 w-100 overflow-auto">
            <div className="d-flex flex-column h-100 bg-white shadow-sm overflow-hidden">
                <div className="p-4 position-relative flex-grow-1" style={{ overflowY: "auto" }}>
                    <div className="alert alert-danger" role="alert">
                        <h4 className="alert-heading">{t("error")}</h4>
                        <p className='p-5 text-center' style={{ fontSize: 'xx-large' }}>{t("cantLoginMesage")}</p>
                        <hr />
                        <div className='row justify-content-center'>
                            <button className="btn btn-md btn-primary p-3" onClick={event => {
                                deleteUserData()
                                userManager.signinRedirect({ state: { path: "/" } })
                            }
                            }>
                                <span className="mdi mdi-18px mdi-login ml-1"></span>
                                {t("retry")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CantLogin;
